import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { CCA_CATEGORIZE_ARTICLES_MUTATION } from './ccaCategorizeArticles.mutation';
import {
  CcaCategorizeArticlesMutation,
  CcaCategorizeArticlesMutationVariables
} from './__generated__/CcaCategorizeArticlesMutation';

export const useCcaCategorizeArticles = () => {
  return useMutation<CcaCategorizeArticlesMutation, CcaCategorizeArticlesMutationVariables>(
    CCA_CATEGORIZE_ARTICLES_MUTATION,
    { client: kmsClient }
  );
};
